import {useSelector} from 'react-redux';

import useCheckFirmware from '../../hooks/fwu/useCheckFirmware';
import fwuService from '../../services/device/fwuService';
import {selectIsFwuPage} from '../../state/selectors/global';
import {selectIotDeviceType} from '../../state/selectors/iotDevice';

const useFwuBackgroundCheck = () => {
    const deviceType = useSelector(selectIotDeviceType);
    const isFWUAvailable = fwuService.isFWUAvailable(deviceType);
    const isBackgroundFwuCheckEnabled = fwuService.getIsBackgroundFwuCheckEnabled();
    const isFwuPage = useSelector(selectIsFwuPage);
    // do not check if isFwuPage, there is its own synchronous check on the page
    const isFwuCheckEnabled = isBackgroundFwuCheckEnabled && isFWUAvailable && !isFwuPage;

    useCheckFirmware({
        isCheckEnabled: isFwuCheckEnabled,
    });
};

export default useFwuBackgroundCheck;
